export enum ELocalisationDialyse {
    LiquideSubstitution = 1,
    Dialysat = 2,
    LiquideRestitution = 3,
    Autre = 4,

}